module.exports = __webpack_public_path__ + "img/travel.e2a0d4bf.svg";